import styled from "styled-components";
import { SignupContainer, SignupWrapper } from "../signup/signup.style";

export const LoginContainer = styled(SignupContainer)``;

export const LoginWrapper = styled(SignupWrapper)``;
